import React, { useState, useEffect, useRef } from 'react';
import './home.css';
import { FaClipboardList, FaCheckCircle, FaFlag, FaBurn } from 'react-icons/fa';
import ReactApexChart from 'react-apexcharts';
import ModalPre from './modalPre';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SimpleSlider from './slider';
const Newhome = () => {
  const total = 15000000000
  const toChartValor = [
    2600000000,
    2500000000,
    2000000000,
    4500000000,
    1000000000,
    1000000000,
    1000000000,
    400000000
  ]

  const containerStyle = {
    height: "min-content",
    minHeight: "600px",
    width: "100%",
    gap: "10px",
    //maxWidth: "1280px",
    display: "grid",
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    color: "#fff",
    borderRadius: "2px",
    margin: "auto",

  };
  const _containerStyle = {
    height: "min-content",
    minHeight: "600px",
    width: "100%",
    gap: "10px",
    //maxWidth: "1280px",
    display: "grid",
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    color: "#fff",
    borderRadius: "2px",
    margin: "auto",
    background: "url('/zazu.png')",
    backgroundSize: window.innerWidth > 700 ? "40%" : "70%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: window.innerWidth > 700 ? "center right" : "center bottom",
  };

  const roadmapDescriptionStyle = {
    fontSize: '14px',
    color: '#fff',
    textAlign: "left",

  };

  const contentContainerStyle = {
    height: "min-content",
    width: "100%",
    display: "grid",
    margin: "auto",
    gap: "10px",
    paddingLeft: window.innerWidth < 720 ? "10px" : "50px",
  };

  const headingStyle = {

    fontSize: "50px",
    fontWeight: "bold",
    margin: "auto",

  };

  const descriptionStyle = {
    textAlign: "justify",
    fontSize: "16px",
    fontWeight: "200",
    height: "100%",
    width: "90%",
    minWidth: "280px",
    margin: "0 auto"
  };

  const buttonContainerStyle = {
    display: "grid",
    gridTemplateColumns: "auto",
    gap: "10px",
    margin: "auto",
  };

  const buttonStyle = {
    background: "#26262680",
    gridTemplateColumns: "auto",
    height: "40px",
    width: "180px",
    fontSize: "16px",
    borderRadius: "90px",
    backgroundColor: "#00000000",
    display: "grid",
    color: "#fff",
    cursor: "pointer",

    border: "1px solid #fff",
    boxShadow: "0px 0px 1px 1px #140523",
    marginBottom: "10px"
  };

  useEffect(() => {
    document.title = "ZAZUCOIN | Home"
  }, []);

  function getlang() {
    return getQuery('lang') == null ? "pt-br" : getQuery('lang')
  }
  function getdata() {
    return anotherLang[getlang()]
  }
  const anotherLang = {
    'pt-br': {
      cr: "Todos os direitos reservados.",
      modal0: {
        title: "ZazuCoin: Decole conosco",
        desc: "Junte-se à ZazuCoin e Voe alto com ZazuCoin agora!",
        button: "Compre ZAZUCOIN",
        buttonhref: "#presale"
      },
      modal1: {
        title: "Quem somos",
        desc: "A ZazuCoin é uma equipe apaixonada por memes e criptomoedas. Nossa missão é criar uma experiência financeira divertida e envolvente para a comunidade de memes. Junte-se a nós enquanto exploramos o mundo das criptomoedas com um toque de diversão! ",
        button: "WHITEPAPER",
        buttonhref: "/whitepaper"
      },
      modal2: {
        title: "Planejamento",
        _step: "Etapa",
        _modal20: <p style={roadmapDescriptionStyle}>*
          Desenvolver e auditar o contrato inteligente BEP-20 da ZazuCoin.<p />*
          Definir a distribuição inicial dos tokens, incluindo alocação para a equipe, reservas e comunidade.<p />*
          Estabelecer um plano de queima de tokens, se aplicável.<p />*
          Implementar funcionalidades de votação e governança comunitária.<p />*
          Realizar testes de segurança e desempenho do contrato inteligente.<p />*
          Criar uma carteira de tokens iniciais para futuras promoções e recompensas.<p />*
          <p />*
        </p>,
        _modal21: <p style={roadmapDescriptionStyle}>*
          Lançar oficialmente a ZazuCoin em exchanges e plataformas de swap.<p />*
          Realizar um evento de lançamento ao vivo para atrair interesse e investidores.<p />*
          Colaborar com influenciadores de memes e criptomoedas para promover a ZazuCoin.<p />*
          Implementar um programa de recompensas para detentores de longo prazo.<p />*
          Divulgar as características exclusivas da ZazuCoin, como sua abordagem descontraída e coleção de NFTs relacionados a memes.
        </p>,
        _modal22: <p style={roadmapDescriptionStyle}>*
          Manter uma comunicação ativa com a comunidade por meio de grupos de Telegram, Discord e outras redes sociais.<p />*
          Realizar competições e eventos regulares para manter a comunidade envolvida.<p />*
          Explorar parcerias estratégicas com outros projetos de criptomoedas e serviços de NFT.<p />*
          Continuar aprimorando as estratégias de marketing com base no desempenho e feedback da comunidade.<p />*
          Monitorar a segurança e o desempenho do contrato inteligente, realizando auditorias periódicas.<p />
        </p>,
      },
      modal3: {
        title: "Tokenomics",
        toChartName: [
          " Pré venda",
          " Liquidez",
          " Projeto",
          " Queima",
          " F. Listagem",
          " Buy Back",
          " Marketing",
          " Airdrop"
        ],
      },
      modal4: {
        title: "Distribuição das taxas",
        fees: [
          " Reflexão",
          " Marketing",
          " Devs",
          " Ação Social"
        ],
        titletxBuy: "TAXA DE COMPRA",
        titletxSell: "TAXA DE VENDA",
        _modal20: {
          title: "Taxas de Reflexão",
          desc: "Essas taxas são devolvidas aos titulares em forma de recompensa em BNB. Segure seus ZAZUCOIN e tenha essa renda passiva em cada transação de Compra e Venda"
        },
        _modal21: {
          title: "Taxa de Marketing",
          desc: "Destina-se a carteira de Marketing onde as taxas serão utilizadas para fazer as divulgações do projeto ( YouTubers, canais, mídias, influencers)."
        },
        _modal22: {
          title: "Taxa de Desenvolvimento",
          desc: "Essa taxa será destinada para a equipe e desenvolvimento do projeto."
        },
        _modal23: {
          title: "Taxa Ação Social",
          desc: "Taxa destinada a ações sociais."
        },
      },
      modal5: {
        title: "Time zazucoin",
        _modal50: "CEO",
        _modal51: "Marketing",
        _modal52: "Desenvolvimento",
      },
      modal6: {
        title: "Compre zazucoin",

      },
      modal7: {
        title: "Parceiros",

      },
    },
    'en-us': {
      "cr": "All rights reserved.",
      "modal0": {
        "title": "ZazuCoin: Fly with us",
        "desc": "Join ZazuCoin and Fly High with ZazuCoin now!",
        "button": "Buy ZAZUCOIN",
        "buttonhref": "#presale"
      },
      "modal1": {
        "title": "About Us",
        "desc": "ZazuCoin is a team passionate about memes and cryptocurrencies. Our mission is to create a fun and engaging financial experience for the meme community. Join us as we explore the world of cryptocurrencies with a twist of fun!",
        "button": "WHITEPAPER",
        "buttonhref": "/whitepaper"
      },
      "modal2": {
        "title": "Roadmap",
        "_step": "Step",
        _modal20: <p style={roadmapDescriptionStyle}>*
          Develop and audit ZazuCoin's BEP-20 smart contract.<p />*
          Define the initial distribution of tokens, including allocation to the team, reserves and community.<p />*
          Establish a token burn plan, if applicable.<p />*
          Implement voting and community governance features.<p />*
          Perform smart contract security and performance testing.<p />*
          Create an initial token wallet for future promotions and rewards.<p />*
          <p />*
        </p>,
        _modal21: <p style={roadmapDescriptionStyle}>*
          Officially launch ZazuCoin on exchanges and swap platforms.<p />*
          Hold a live launch event to attract interest and investors.<p />*
          Collaborate with meme and cryptocurrency influencers to promote ZazuCoin.<p />*
          Implement a rewards program for long-term holders.<p />*
          Promote ZazuCoin's unique features, such as its laid-back approach and collection of meme-related NFTs.
        </p>,
        _modal22: <p style={roadmapDescriptionStyle}>*
          Maintain active communication with the community through Telegram groups, Discord and other social networks.<p />*
          Hold regular competitions and events to keep the community involved.<p />*
          Explore strategic partnerships with other cryptocurrency projects and NFT services.<p />*
          Continue to improve marketing strategies based on performance and community feedback.<p />*
          Monitor the security and performance of the smart contract by carrying out periodic audits.<p />
        </p>,
      },
      "modal3": {
        "title": "Tokenomics",
        "toChartName": [
          "Pre-sale",
          "Liquidity",
          "Project",
          "Burn",
          "F. Listing",
          "Buy Back",
          "Marketing",
          "Airdrop"
        ]
      },
      "modal4": {
        "title": "Fee Distribution",
        "fees": [
          "Reflection",
          "Marketing",
          "Devs",
          "Social Action"
        ],
        "titletxBuy": "BUY FEE",
        "titletxSell": "SELL FEE",
        "_modal20": {
          "title": "Reflection Fee",
          "desc": "These fees are returned to holders as a reward in BNB. Hold your ZAZUCOIN and have this passive income on every buy and sell transaction."
        },
        "_modal21": {
          "title": "Marketing Fee",
          "desc": "Intended for the marketing wallet, where fees will be used to promote the project (YouTubers, channels, media, influencers)."
        },
        "_modal22": {
          "title": "Development Fee",
          "desc": "This fee will be allocated to the team and project development."
        },
        "_modal23": {
          "title": "Social Action Fee",
          "desc": "Fee allocated to social actions."
        }
      },
      "modal5": {
        "title": "zazucoin Team",
        "_modal50": "CEO",
        "_modal51": "Marketing",
        "_modal52": "Development"
      },
      modal6: {
        title: "Buy zazucoin",

      },
      modal7: {
        title: "Partners",

      },
    },
  }

  const Footer = () => {
    const footerStyle = {
      padding: "20px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
    };
    return (
      <footer style={footerStyle}>

        <div className="redes center">

          <a href="https://twitter.com/zazucoin">
            <div className="twiter"></div>
          </a>

          <a href="https://t.me/zazucoin_pt">
            <div className="telegram"></div>
          </a>

        </div>
        <p>&copy; 2023 Zazucoin. {getdata().cr}</p>

      </footer>
    );
  };

  const Content0 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {

      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    return (
      <div ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1280px",
          margin: "auto",
        }}>

          <div style={_containerStyle}>
            <div style={contentContainerStyle}>
              <div>
                <p className='gradient' style={headingStyle}>{getdata().modal0.title}</p>
                <span style={descriptionStyle}>
                  <br />
                  {getdata().modal0.desc}
                </span>
                <br />
                <br />
                <div style={buttonContainerStyle}>
                  <div style={buttonStyle} onClick={() => {
                    window.location.href = getdata().modal0.buttonhref
                  }}>
                    <p style={{ textAlign: "center", margin: "auto", fontWeight: "bold" }}>
                      {getdata().modal0.button}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              height: "280px",
              width: "280px",
            }}></div>
          </div>
        </div>
      </div>
    )
  }
  /* */
  const Content1 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {

      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    return (
      <div ref={ref} id={'QuemSomos'} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1280px",
          margin: "auto",
          color: "#fff",
          textAlign: "center"
        }}>


          <div style={contentContainerStyle}>
            <div style={{ maxWidth: "700px" }}>
              <p className='gradient' style={headingStyle}>{getdata().modal1.title}</p>
              <span style={descriptionStyle}>
                <br />
                {getdata().modal1.desc}
              </span>
              <br />
              <br />
              <div className="redes center">
                <div className="redes center">
                  <a href="https://twitter.com/zazucoin">
                    <div className="twiter"></div>
                  </a>

                  <a href="https://t.me/zazucoin_pt">
                    <div className="telegram"></div>
                  </a>

                </div>

              </div>
              <div style={buttonContainerStyle}>
                <div className='center' style={buttonStyle} onClick={() => {
                  window.location.href = getdata().modal1.buttonhref;
                }}>
                  <p style={{ textAlign: "center", margin: "auto", fontWeight: "bold" }}>
                    {getdata().modal1.button}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const Content2 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [Info, setInfo] = useState(getTokennomics());
    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    function getTokennomics() {

      let toPercent = []

      for (let index = 0; index < toChartValor.length; index++) {
        toPercent.push(parseFloat((toChartValor[index] / total) * 100).toFixed(2))
      }

      return {
        itens: getdata().modal3.toChartName,
        value: toChartValor,
        percent: toPercent
      }
    }
    const PortChart = (props) => {
      return (
        <div id="chart" >
          {props.obj != undefined && <ReactApexChart options={props.obj.options} series={props.obj.series} type={props.type} width={"100%"} />}
        </div>
      )
    }

    function Portfólio(props) {
      const [chartdata, setChartData] = useState(undefined);
      useEffect(() => {
        data()
      }, [])

      async function data() {

        setChartData({
          series: toChartValor,
          options: {
            chart: {
              width: "100%",
              type: 'donut',
            },
            plotOptions: {
              pie: {
                donut: {
                  size: '50%'
                }
              }
            },
            labels: getdata().modal3.toChartName,
            legend: {
              show: false
            },
            dataLabels: {
              enabled: false,
              formatter: function (val) {
                return new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                }).format(val)
              },
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: "100%"
                },
                legend: {
                  position: 'bottom'
                }
              }
            },]
          },
        })

      }

      return (
        <PortChart obj={chartdata} type={"donut"} />
      )
    }

    return (
      <div id={'Tokenomics'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <p className="gradient center" style={headingStyle}>{getdata().modal3.title}</p>
        <div style={{
          width: "100%",
          maxWidth: "1280px",
          margin: "auto"
        }}>


          <div style={containerStyle}>

            <div style={contentContainerStyle}>
              <div>
                <Portfólio />
              </div>
            </div>
            <div style={contentContainerStyle}>
              <div>
                <span style={descriptionStyle}>
                  <br />
                  <br />
                  {Info.itens.map((e, i) =>
                    <span style={{
                      display: "grid", textAlign: "left",
                      fontSize: "20px",
                      paddingLeft: "10px",
                      margin: "5px auto",

                    }}>

                      <span> {e} - <span className='gradient' style={{ fontSize: "24px" }}> {Info.percent[i]} % </span></span>

                    </span>
                  )}

                  <br />

                  <br />
                </span>
                <br />
                <br />

              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
  const Content3 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {

      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    return (


      <div id={'Planejamento'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1366px",
          margin: "auto",
          width: "100%",
          color: "#fff",
          textAlign: "center"
        }}>

          <div style={contentContainerStyle}>
            <p className='gradient' style={headingStyle}>{getdata().modal2.title}</p>
            <br />
            <br />
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: "5px" }}>
              <span style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                paddingLeft: "10px",
                margin: "0 auto",
                width: "100%",
                borderLeft: "3px solid #fff",
                gridTemplateRows: "30px auto"
              }}>
                <p className='gradient' style={{}}>1º {getdata().modal2._step}</p>
                {getdata().modal2._modal20}
              </span>

              <span style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                paddingLeft: "10px",
                margin: "0 auto",
                width: "100%",
                borderLeft: "3px solid #fff",
                gridTemplateRows: "30px auto"
              }}>
                <p className='gradient' style={{}}>2º {getdata().modal2._step}</p>
                {getdata().modal2._modal21}
              </span>

              <span style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                paddingLeft: "10px",
                margin: "0 auto",
                width: "100%",
                borderLeft: "3px solid #fff",
                gridTemplateRows: "30px auto"
              }}>
                <p className='gradient' style={{}}>3º {getdata().modal2._step}</p>
                {getdata().modal2._modal22}
              </span>
            </div>
          </div>


        </div>
      </div>
    )
  }
  const Content4 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {

      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    return (


      <div id={'Taxas'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1366px",
          margin: "auto",
          width: "100%",
          color: "#fff",
          textAlign: "center"
        }}>

          <div style={contentContainerStyle}>
            <p className='gradient' style={headingStyle}>{getdata().modal4.title}</p>
            <br />
            <br />
            <div style={{ width: "95%", margin: "auto", display: "grid", gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: "5px" }}>
              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>
                <p className='gradient' style={{}}>{getdata().modal4.titletxBuy} 10%</p>
                <p style={{}}><span className='gradient' style={{}}>4%</span> {getdata().modal4.fees[0]}</p>
                <p style={{}}><span className='gradient' style={{}}>3%</span> {getdata().modal4.fees[1]}</p>
                <p style={{}}><span className='gradient' style={{}}>2%</span> {getdata().modal4.fees[2]}</p>
                <p style={{}}><span className='gradient' style={{}}>1%</span> {getdata().modal4.fees[3]}</p>
              </span>

              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>
                <p className='gradient' style={{}}>{getdata().modal4.titletxSell} 10%</p>
                <p style={{}}><span className='gradient' style={{}}>4%</span> {getdata().modal4.fees[0]}</p>
                <p style={{}}><span className='gradient' style={{}}>3%</span> {getdata().modal4.fees[1]}</p>
                <p style={{}}><span className='gradient' style={{}}>2%</span> {getdata().modal4.fees[2]}</p>
                <p style={{}}><span className='gradient' style={{}}>1%</span> {getdata().modal4.fees[3]}</p>


              </span>


            </div>
            <div style={{ width: "95%", margin: "auto", display: "grid", gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: "5px" }}>
              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>
                <p className='gradient' style={{ fontSize: "22px" }}>{getdata().modal4._modal20.title}</p>
                <p style={roadmapDescriptionStyle}>{getdata().modal4._modal20.desc}</p>
              </span>
              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>
                <p className='gradient' style={{ fontSize: "22px" }}>{getdata().modal4._modal21.title}</p>
                <p style={roadmapDescriptionStyle}>{getdata().modal4._modal21.desc}
                </p>

              </span>
              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>

                <p className='gradient' style={{ fontSize: "22px" }}>{getdata().modal4._modal22.title}</p>
                <p style={roadmapDescriptionStyle}>{getdata().modal4._modal22.desc}</p>

              </span>
              <span className='borderfull' style={{
                display: "grid",
                textAlign: "left",
                fontSize: "20px",
                padding: "5px",
                margin: "0 auto",
                width: "100%",

                borderRadius: "10px",
                gridTemplateRows: "40px auto"
              }}>
                <p className='gradient' style={{ fontSize: "22px" }}>{getdata().modal4._modal23.title}</p>
                <p style={roadmapDescriptionStyle}>{getdata().modal4._modal23.desc}</p>
              </span>

            </div>
          </div>


        </div>
      </div>
    )
  }
  const Content5 = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {

      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);
    function ModalDevs(props) {
      return (
        <span className='borderfull' style={{
          display: "grid",
          textAlign: "left",
          fontSize: "20px",
          padding: "5px",
          margin: "0 auto",
          width: "100%",
          borderRadius: "10px",
          gridTemplateRows: "  auto 40px"
        }}>
          <div style={{
            height: "280px",
            width: "280px",
            color: "#fff",
            margin: "auto",

            display: "grid",
            borderRadius: "10px",
          }}>
            <div style={{
              height: "200px",
              width: "200px",
              color: "#fff",
              margin: "auto",
              background: "url(" + props.img + ")",
              backgroundSize: "100%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              display: "grid",
              borderRadius: "360px",
            }}>

            </div>
          </div>
          <p className='gradient center' style={{ fontSize: "22px" }}>{props.what}</p>

        </span>
      )
    }

    return (


      <div id={'Team'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1366px",
          margin: "auto",
          width: "100%",
          color: "#fff",
          textAlign: "center"
        }}>

          <div style={contentContainerStyle}>
            <p className='gradient' style={headingStyle}>{getdata().modal5.title}</p>
            <br />
            <br />

            <div style={{ width: "95%", margin: "auto", display: "grid", gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: "5px" }}>
              <ModalDevs img={"/icons/photo_5039778934127963209_x.jpg"} what={"CEO"} />
              <ModalDevs img={"/icons/photo_5062313708407073661_x.jpg"} what={"Marketing"} />
              <ModalDevs img={"/icons/photo_5062313708407073662_x.jpg"} what={getdata().modal5._modal52} />

            </div>
          </div>


        </div>
      </div>
    )
  }
  const Buymodal = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);

    return (


      <div id={'Buymodal'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1366px",
          margin: "auto",
          width: "100%",
          color: "#fff",
          textAlign: "center"
        }}>

          <div style={contentContainerStyle}>
            <p className='gradient' style={headingStyle}>{getdata().modal6.title}</p>
            <br />
            <br />
            <ModalPre />

          </div>


        </div>
      </div>
    )
  }

  const Partnerships = () => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => observer.disconnect();
    }, [isIntersecting]);

    useEffect(() => {
      if (isIntersecting) {
        ref.current.querySelectorAll("div").forEach((el) => {
          el.classList.add("slide-in");
        });
      }
    }, [isIntersecting]);

    return (
      <div id={'Partness'} ref={ref} style={{
        height: "min-content",
        minHeight: "480px",
        width: "100%",
        margin: "auto",
        display: 'grid'
      }}>
        <div style={{
          maxWidth: "1366px",
          margin: "auto",
          width: "100%",
          color: "#fff",
          textAlign: "center"
        }}>

          <div style={contentContainerStyle}>
            <p className='gradient' style={headingStyle}>{getdata().modal7.title}</p>
            <br />
            <br />
            <div style={{
              height: "min-content",
              minHeight: "150px",
              width: "100%",
              display: "grid",
              margin: "auto",
            }}>
              <div style={{
                height: "min-content",
                width: "100%",
                display: "grid",
                margin: "auto",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr)",
                gap: "25px",
              }}>

                <div onClick={() => { }} style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",
                  background: "url('./icons/po2329m99b-poocoin-logo-moonlight-token.png')",
                  backgroundSize: "240px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: "grid",
                  borderRadius: "10px",
                }}>
                  <p style={{ color: "#444" }}></p>
                </div>
                <div onClick={() => { }} style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",
                  background: "url('https://dexview.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2Fabb35737-bbc2-482d-a8dd-5e0f0f013c9c%2Fdexview-white-text-transparent.png?id=66a5b7d6-5361-41bd-a09e-6b8565589d77&table=block&spaceId=f2f78fd3-79ff-4ce0-bc9c-ba15ee5eba0f&width=2000&userId=&cache=v2')",
                  backgroundSize: "250px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: "grid",
                  borderRadius: "10px",
                }}>
                  <p style={{ color: "#444" }}></p>
                </div>
                <div onClick={() => { }} style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",
                  background: "url('./icons/color-white.png')",
                  backgroundSize: "250px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: "grid",
                  borderRadius: "10px",
                }}>
                  <p style={{ color: "#444" }}></p>
                </div>
                <div onClick={() => { }} style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",
                  background: "url('https://bscscan.com/assets/bsc/images/svg/logos/logo-bscscan-light.svg?v=23.10.3.0')",
                  backgroundSize: "250px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: "grid",
                  borderRadius: "10px",
                }}>
                  <p style={{ color: "#444" }}></p>
                </div>
                <svg style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",

                  display: "grid",
                  borderRadius: "10px"
                }} fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 29" class="cmc-logo-img"><path d="M28.442 14.445v-.056C28.414 6.466 22.032 0 14.221 0S0 6.466 0 14.445c0 7.98 6.381 14.433 14.221 14.433a13.978 13.978 0 0 0 9.66-3.866 1.309 1.309 0 0 0-1.766-1.933l-.028.028a11.5 11.5 0 0 1-16.572-.755l6.075-9.742v4.508c0 2.154.84 2.855 1.546 3.051.706.196 1.765.054 2.912-1.765l3.333-5.412c.089-.158.192-.308.306-.449v2.745c0 2.015.812 3.639 2.211 4.422a4.071 4.071 0 0 0 4.173-.167c1.616-1.049 2.484-2.886 2.371-5.098Zm-3.696 2.835a1.529 1.529 0 0 1-1.546.111c-.56-.335-.897-1.09-.897-2.126v-3.173c0-1.51-.588-2.603-1.595-2.881-1.709-.516-2.995 1.595-3.472 2.379l-3.015 4.842V10.47c-.028-1.371-.477-2.183-1.317-2.436-.56-.167-1.4-.082-2.211 1.15L3.946 19.989a11.971 11.971 0 0 1-1.371-5.544c0-6.523 5.234-11.814 11.646-11.814 6.412 0 11.646 5.291 11.646 11.814v.057c.067 1.258-.337 2.268-1.12 2.77v.008ZM48.263 9.518a1.407 1.407 0 0 1 .645 1.092 1.24 1.24 0 0 1-1.204 1.232 2.062 2.062 0 0 1-.449-.085 4.61 4.61 0 0 0-2.716-.922c-2.379 0-4.002 1.93-4.002 4.337s1.652 4.312 4.002 4.312a4.34 4.34 0 0 0 3.023-1.232c.206-.145.45-.223.701-.224a1.134 1.134 0 0 1 .99 1.709c-.097.17-.235.315-.402.42a6.647 6.647 0 1 1-4.283-11.758c1.318-.02 2.61.37 3.695 1.119ZM54.925 12.309a4.745 4.745 0 0 0-4.765 4.71 4.82 4.82 0 0 0 4.76 4.79c2.464 0 4.564-2.212 4.564-4.79 0-2.576-2.067-4.71-4.559-4.71Zm-.028 7.167c-1.175 0-2.155-1.064-2.155-2.436 0-1.427.98-2.296 2.155-2.296 1.093 0 2.015.897 2.015 2.296 0 1.4-.922 2.444-2.015 2.444v-.008ZM61.056 20.352v-6.608a1.29 1.29 0 0 1 1.289-1.314 1.306 1.306 0 0 1 1.289 1.314v6.608a1.306 1.306 0 0 1-1.289 1.315 1.328 1.328 0 0 1-1.289-1.315ZM60.86 9.938a1.505 1.505 0 0 1 1.485-1.547 1.528 1.528 0 0 1 1.51 1.547 1.497 1.497 0 0 1-2.994 0ZM68.559 16.77v3.582a1.289 1.289 0 1 1-2.578 0v-6.915a.994.994 0 1 1 1.988 0 3.738 3.738 0 0 1 2.835-1.12c2.577 0 3.724 1.932 3.724 4.144v3.891a1.289 1.289 0 1 1-2.578 0V16.77c0-1.121-.139-2.062-1.763-2.062-1.146 0-1.623.951-1.623 2.062h-.005ZM82.865 18.141a.835.835 0 0 1-.673-.338l-2.995-3.247v5.796a1.289 1.289 0 1 1-2.577 0V8.873a.546.546 0 0 1 .477-.335.9.9 0 0 1 .56.335l4.788 5.376a.624.624 0 0 0 .42.258.701.701 0 0 0 .42-.258l4.786-5.376a.843.843 0 0 1 .559-.335.49.49 0 0 1 .477.335v11.48a1.29 1.29 0 0 1-1.289 1.314 1.307 1.307 0 0 1-1.288-1.315v-5.796l-2.998 3.247a1.031 1.031 0 0 1-.67.338h.003ZM107.08 14.698h-.281c-1.623.082-1.93 1.008-1.93 2.062v3.582a1.29 1.29 0 0 1-1.289 1.289 1.29 1.29 0 0 1-1.288-1.29v-6.903a.997.997 0 0 1 .995-.995.996.996 0 0 1 .994.995c.951-.897 1.735-1.093 2.518-1.122h.258a1.207 1.207 0 0 1 1.175 1.204 1.18 1.18 0 0 1-1.147 1.178h-.005ZM117.018 19.736c.118.185.186.397.196.616a1.346 1.346 0 0 1-1.289 1.289c-.446 0-.84-.338-1.147-.73l-2.966-3.448v2.86a1.288 1.288 0 0 1-2.577 0V9.828a1.287 1.287 0 0 1 2.199-.911c.242.241.378.57.378.91v6.55l2.966-3.274c.307-.337.673-.7 1.119-.7a1.289 1.289 0 0 1 1.232 1.26 1.09 1.09 0 0 1-.168.587l-2.35 2.577 2.407 2.913v-.003ZM132.584 21.78h-.701c-1.959 0-3.108-.869-3.108-3.92v-3.162h-.67a1.19 1.19 0 1 1 0-2.382h.66V9.881a1.282 1.282 0 0 1 .789-1.214c.158-.066.328-.1.499-.1a1.311 1.311 0 0 1 1.289 1.314v2.428h1.062a1.185 1.185 0 0 1 1.149 1.203 1.222 1.222 0 0 1-1.149 1.178h-1.062v2.66c0 1.763.082 2.126.866 2.126h.366a1.152 1.152 0 0 1 1.147 1.15 1.174 1.174 0 0 1-1.147 1.147l.01.007ZM145.04 9.518a1.41 1.41 0 0 1 .644 1.092 1.239 1.239 0 0 1-1.204 1.232 2.135 2.135 0 0 1-.448-.085 4.597 4.597 0 0 0-2.714-.922c-2.381 0-4.005 1.93-4.005 4.337s1.652 4.312 4.005 4.312a4.34 4.34 0 0 0 3.023-1.232c.205-.144.449-.222.699-.224a1.143 1.143 0 0 1 .816.332 1.134 1.134 0 0 1 .176 1.378 1.184 1.184 0 0 1-.405.418 6.639 6.639 0 0 1-5.978 1.3 6.642 6.642 0 0 1-4.853-7.268 6.642 6.642 0 0 1 6.548-5.789 6.27 6.27 0 0 1 3.696 1.119ZM98.99 12.402a.982.982 0 0 0-.982 1.007l-.054.31a4.026 4.026 0 0 0-2.997-1.428c-2.518 0-4.337 2.126-4.337 4.7 0 2.575 1.79 4.789 4.198 4.789 1.008 0 2.603-.449 3.108-1.428l.057.307a.964.964 0 0 0 1.007.982 1.006 1.006 0 0 0 1.008-1.008v-7.216a1.03 1.03 0 0 0-1.008-1.015Zm-3.752 7.082c-1.147 0-2.044-1.09-2.044-2.436 0-1.345.923-2.32 2.044-2.32 1.12 0 2.129.923 2.129 2.32 0 1.397-.982 2.436-2.13 2.436ZM126.425 16.824c-.057-2.884-1.933-4.508-4.423-4.508-3.092 0-4.397 2.24-4.397 4.817 0 3.276 2.158 4.675 4.761 4.675.979 0 2.015-.141 2.798-.729a1.135 1.135 0 0 0 .56-.923 1.057 1.057 0 0 0-1.031-1.064c-.237.002-.469.07-.67.196a4.173 4.173 0 0 1-1.681.335c-.644 0-2.128-.258-2.128-1.791h5.2a1.031 1.031 0 0 0 1.011-1.008Zm-6.217-.65c0-1.09 1.15-1.453 1.848-1.453.699 0 1.848.363 1.876 1.453h-3.724ZM155.31 12.402a.984.984 0 0 0-.703.296.976.976 0 0 0-.277.711l-.056.31a4.02 4.02 0 0 0-2.995-1.428c-2.52 0-4.34 2.126-4.34 4.7 0 2.575 1.804 4.789 4.198 4.789 1.008 0 2.606-.449 3.108-1.428l.057.307a.974.974 0 0 0 .292.708.965.965 0 0 0 .716.274 1.01 1.01 0 0 0 .932-.622c.05-.122.076-.253.076-.386v-7.216a1.032 1.032 0 0 0-1.008-1.015Zm-3.753 7.082c-1.118 0-2.043-1.09-2.043-2.436 0-1.345.897-2.32 2.043-2.32 1.147 0 2.129.923 2.129 2.32 0 1.397-.974 2.436-2.123 2.436h-.006ZM163.657 12.309a4.14 4.14 0 0 0-3.023 1.232c0-.642-.42-1.119-.979-1.119a1.007 1.007 0 0 0-1.01 1.008v10.863a1.291 1.291 0 0 0 1.288 1.288 1.29 1.29 0 0 0 1.289-1.288v-3.268c.698.53 1.819.755 2.577.773 2.436 0 4.201-2.211 4.201-4.788 0-2.578-1.85-4.701-4.343-4.701Zm-.309 7.167c-1.147 0-2.126-1.03-2.126-2.435s.979-2.32 2.126-2.32c1.147 0 2.044.923 2.044 2.32 0 1.352-.894 2.443-2.044 2.443v-.008Z">
                  </path>
                </svg>
                <div onClick={() => { }} style={{
                  cursor: "pointer",
                  height: "100px",
                  width: "250px",
                  color: "#fff",
                  margin: "auto",
                  background: "url('https://static.coingecko.com/s/coingecko-logo-white-ea42ded10e4d106e14227d48ea6140dc32214230aa82ef63d0499f9c1e109656.png')",
                  backgroundSize: "250px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: "grid",
                  borderRadius: "10px",
                }}>
                  <p style={{ color: "#444" }}></p>
                </div>

              </div>
            </div>

          </div>


        </div>
      </div>

    );
  }
  function getQuery(query) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const foo = params.get(query);
    return foo
  }

  //('refFrom') == null      <TokenInfo />  <Buymodal />
  /*
     <video loop ref={vidRef}>
        <source src={"https://rr1---sn-4ox-ixal.googlevideo.com/videoplayback?expire=1691432603&ei=O-LQZJuWMf6px_AP7Iq2-Ag&ip=185.94.33.191&id=o-AArRomw68Qjxcr79sstttpHvLiV1Nte5b5misbnsK3_7&itag=22&source=youtube&requiressl=yes&mh=DO&mm=31%2C29&mn=sn-4ox-ixal%2Csn-ixh7yn7e&ms=au%2Crdu&mv=m&mvi=1&pl=22&initcwndbps=548750&spc=UWF9fyvSunj8CYkL-672eWZXH5BFG4k&vprv=1&svpuc=1&mime=video%2Fmp4&cnr=14&ratebypass=yes&dur=132.051&lmt=1674558596802879&mt=1691410657&fvip=3&fexp=24007246%2C51000011%2C51000023&beids=24350018&c=ANDROID&txp=6211224&sparams=expire%2Cei%2Cip%2Cid%2Citag%2Csource%2Crequiressl%2Cspc%2Cvprv%2Csvpuc%2Cmime%2Ccnr%2Cratebypass%2Cdur%2Clmt&sig=AOq0QJ8wRgIhAOlETPgI-j-tQknkWSZKWNFoMihplza6PeU9eqZVm_nwAiEAtoGvAytuwcnRq0e-iQvk2Ewv7tm6bAR50UqX7eQTTEA%3D&lsparams=mh%2Cmm%2Cmn%2Cms%2Cmv%2Cmvi%2Cpl%2Cinitcwndbps&lsig=AG3C_xAwRQIhAPj6SbPUW6ChF_x-zSe3BnwWZBxqV9wYWu1-bf4uozvJAiB8LeE6u7JgEE6U3UYEwjFpWPQjxMSzgXwj1zkXU3_KPQ%3D%3D&title=Drill%20Trap%20-%20by%20StereojamMusic%20[No%20Copyright%20Music]%20/%20Explosion"} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
       */

  const settings = {
    className: "",
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 4,
    initialSlide: 0,

    autoplay: false,
    autoplaySpeed: 1000,
    speed: 1200
  }
  return (
    <div style={{ display: "grid", gap: "50px" }}>

      <Content0 />
      <Content1 />
      <Content3 />

      <Partnerships />




      <Footer />
    </div>
  );

}

export default Newhome;